// Next
import Script from "next/script";

interface GoogleTagManagerProps {
    gtmId: string;
    isInHead: boolean;
}

const GoogleTagManager = ({gtmId, isInHead}: GoogleTagManagerProps) => {
    const scriptContent = `
        // Global GTM Snippet - '${gtmId}'   
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmId}');
    `;

    if (isInHead) {
        return <Script id={"gtm-script"} dangerouslySetInnerHTML={{__html: scriptContent}} strategy={"beforeInteractive"}/>
    }
    return <script dangerouslySetInnerHTML={{__html: scriptContent}}/>
};

export default GoogleTagManager;
